// const serverApiUrl = 'https://dev-api.store.yellowcat.dev/'
const serverApiUrl = 'https://api.yellowcatstore.com/'

export { 
    serverApiUrl
};